import _t from 'i18n!nls/ai-coach-platform';

/**
 * Returns the generic display labels used in place of the "Coach" brand name.
 *
 * @returns featureNameLabel (capitalized, for sentence starts) and
 *          featureNameLabelLower (lowercase, for mid-sentence use)
 */
export const getFeatureNameLabels = (): { featureNameLabel: string; featureNameLabelLower: string } => ({
  featureNameLabel: _t('This tool'),
  featureNameLabelLower: _t('this tool'),
});
